import {
  SimpleShowLayout,
  Show,
  TextField,
  SelectField,
  Labeled,
  FunctionField,
  EditButton,
  useRecordContext,
} from "react-admin";
import { Grid, useMediaQuery } from "@mui/material";
import BackButtonToolbar from "features/BackButtonToolbar";
import SecuredComponent from "server/security/SecuredComponent";
import permissions from "app/permissions";
import { settings } from "app";
import { MoneyField } from "server/components/Fields/MoneyField";
import { MonthsOfTheYear } from "utils/choices";
import { healthInsuranceId } from "./utils";
import { SectionTitle } from "features/SectionTitle";

const ShowEditButton = () => {
  const record = useRecordContext();
  if (!record) return null;

  return (
    <EditButton
      variant="contained"
      size="medium"
      record={{ id: healthInsuranceId(record) }}
    />
  );
};

const ShowHealthInsurances = () => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));

  return (
    <Show
      title="Детайли за здравна осигуровка"
      actions={
        <BackButtonToolbar
          additionalButton={
            <SecuredComponent permission={permissions.canManageHealthInsurances}>
              <ShowEditButton />
            </SecuredComponent>
          }
        />
      }
    >
      <SimpleShowLayout>
        <SectionTitle
          title="Информация"
          textAlign="center"
          sx={{ marginTop: "2rem" }}
        />

        <Grid
          container
          spacing={2}
          sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
        >
          <Grid
            item
            xs={12}
            md={3}
          >
            <Labeled label="От година">
              <TextField source="year" />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={3}
          >
            <Labeled label="От месец">
              <SelectField
                source="month"
                choices={MonthsOfTheYear}
              />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={3}
          >
            <Labeled label="Стойност">
              <MoneyField source="amount" />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={3}
          >
            <Labeled label="Процент">
              <FunctionField
                source="percentage"
                render={record => record.percentage + "%"}
              />
            </Labeled>
          </Grid>
        </Grid>
      </SimpleShowLayout>
    </Show>
  );
};

export default ShowHealthInsurances;
